/**
 * 统计
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/4/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from "react";
import "./index.less";
import IconFont from "@components/IconFont/index";
class Statistics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let { model } = this.props;
        let list = [
            {
                iconName: "icon-denglurenshu",
                name: __getServerLanguage('DengLuRenShu'),
                num: model.loginNumTotal,
                fontSize:'30px'
            },
            {
                iconName: "icon-xinkehuchengjiaorenshu",
                name: __getServerLanguage('XinKeHuChengJiaoRenShu'),
                num: model.orderNewBuyerTotal,
            },
            {
                iconName: "icon-zongchengjiaorenshu",
                name: __getServerLanguage('ZongChengJiaoRenShu'),
                num: model.orderBuyerTotal,
            },
        ];
        return (
            <div>
                <ul className="statistics-wrap">
                    {list.map(function (item, index) {
                        return (
                            <li key={index} style={{flex: '0 0 33%'}}>
                                <IconFont
                                    style={{fontSize:item.fontSize||'35px'}}
                                    type={item.iconName}
                                    className="img"
                                ></IconFont>
                                <div>
                                    <p className="statistics-title">
                                        {item.name}
                                    </p>
                                    <p className="num">{item.num}</p>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

Statistics.defaultProps = {
    model: {},
};

Statistics.propTypes = {};
export default Statistics;
